import styled from 'styled-components';
import { color } from 'styles/pallete';

export const container = styled.div`
	width: 100%;
	max-height: 40vh;
	height: fit-content;
	display: flex;
	align-items: center;
	flex-direction: column;
	justify-content: center;
	gap: 1rem;
	background-color: ${color.interface.white};
	transition: all ease 0.5s;
	padding: 10px;
`;

export const img = styled.img`
	min-width: 100%;
	min-height: 100%;
	max-width: 100%;
	max-height: 100%;
	width: 100%;
	height: 100%;
	object-fit: fill; // Evita distorção, mas pode criar espaços em branco
	border-radius: 10px;
`;
